import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Footer, ListContainer } from "./style";
import { connect } from "react-redux";
import Button from "../../../../../components/button";
import { isEqual } from "lodash";
import { reduxForm } from "redux-form";
import { BoxLoading } from "../../../../../components/loading";
import * as ProjectAction from "../../../../../actions/project";
import logout from "../../../../../assets/logout";
import { CREATE } from "../../../../../constants/companyFormType";
import { NEW_OR_EDIT_COMPANY } from "../../../../../constants/urls";
import getUserIdentification from "../../../../../assets/getUserIdentification";
import { checkPremiumFeature } from "../../../../../assets/checkPremium";
import { ADD_PROJECT } from "../../../../../constants/premiumActions";
import checkUserProfileIsComplete from "../../../../../assets/checkUserProfileIsComplete";
import { ACTION_NEED_COMPLETED_PROFILE } from "../../../../../constants/otherTexts";
import { PROJECT_USER_STATE } from "../../../../../constants/projectUser";
import { selectProjectUser } from "../../../../../assets/selectProjectUserOrPanel";
import ErrorHandle from "../../../../../components/error/mainError";
import { renderPremiumText } from "../../../../../assets/renderPremiumIconWithText";

class ProjectList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moreMenu: false,
      projectsData: "",
      originProjectsData: ""
    };
    this.newProjectButtonHandler = this.newProjectButtonHandler.bind(this);
  }
  componentDidMount() {
    if (!this.props.projectsAreFetched) {
      this.props.getProjects();
    }
  }
  static getDerivedStateFromProps(props, state) {
    let result = [];
    if (!isEqual(props.projects, state.originProjectsData)) {
      result.projectsData = props.projects;
      result.originProjectsData = props.projects;
    }
    return result;
  }

  newProjectButtonHandler() {
    const { history } = this.props;
    const showPremiumMessage = checkPremiumFeature(ADD_PROJECT, true);
    if (!showPremiumMessage) {
      const userProfileIsComplete = checkUserProfileIsComplete(
        ACTION_NEED_COMPLETED_PROFILE.NEW_PROJECT
      );
      if (userProfileIsComplete) {
        history.push({
          pathname: NEW_OR_EDIT_COMPANY,
          state: { type: CREATE, showCopyTopicsFromOthers: true }
        });
      }
    }
  }
  render() {
    const { projectsData: projects } = this.state;
    const { loading, listError, user } = this.props;

    let projectsData = projects.filter(
      project => !(project.state === PROJECT_USER_STATE.PENDING)
    );
    return (
      <React.Fragment>
        <ListContainer>
          {!loading && (
            <React.Fragment>
              {projectsData.length !== 0 ? (
                projectsData.map(project => {
                  let userName = getUserIdentification(project.owner);
                  return (
                    <div
                      className="list-items"
                      key={project.id}
                      onClick={() => selectProjectUser(project)}
                    >
                      <div className="text-bar">
                        <div className="project-characteristics">
                          <div className="project-name">
                            <span className="inner-text">{project.name}</span>
                          </div>
                        </div>
                        {project.owner.id !== user.id && (
                          <div className="user-name">مالک شرکت: {userName}</div>
                        )}
                      </div>
                      <div className="click-hint-text">
                        <div className="wrapper">
                          ورود به شرکت
                          <i className="icon mapsa-left-arrow-chevron" />
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div style={{ width: "170px", margin: "0 auto" }} />
              )}
            </React.Fragment>
          )}
          <ErrorHandle message={listError} request={this.props.getProjects} />
          {loading && <div className="loading-wrapper">{BoxLoading()}</div>}
          {/*{loading && BoxLoading()}*/}
        </ListContainer>
        {!loading && (
          <Footer>
            <Button btn="secondary" onClick={this.newProjectButtonHandler}>
              <span
                className="text-button"
                dangerouslySetInnerHTML={{
                  __html: renderPremiumText("ایجاد شرکت جدید", showMessage =>
                    checkPremiumFeature(ADD_PROJECT, showMessage)
                  )
                }}
              />
            </Button>
            <Button btn="outline" borderless onClick={logout}>
              خروج
            </Button>
          </Footer>
        )}
      </React.Fragment>
    );
  }
}

const displayableProjects = (data, currentProject) => {
  const activeProjects = data.active_projects.filter(
    project => project.id !== currentProject.id
  );
  return data ? [...activeProjects] : [];
};

const mapStateToProps = store => {
  return {
    projects: displayableProjects(store.Project, store.Init.data.project),
    loading: store.Project.loading,
    listError: store.Project.error,
    projectsAreFetched: store.Project.is_fetched,
    user: store.User.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProjects: () => {
      dispatch(ProjectAction.get());
    }
  };
};

ProjectList = reduxForm({
  form: "add_project"
})(ProjectList);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProjectList)
);
